import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 39 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.679 21.736 32.54 8.874c.628-.629 1.571.314.943.943L20.15 23.15c-.219.219-.475.247-.69.165a.73.73 0 0 1-.299-.184 14.34 14.34 0 0 0-.428-.455l-6.192-6.193c-.629-.628.314-1.57.942-.942l6.196 6.195Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.679 21.736 25.54 8.874c.628-.629 1.571.314.942.943L13.15 23.15c-.219.219-.475.247-.69.165a.73.73 0 0 1-.299-.184 14.34 14.34 0 0 0-.428-.455L5.54 16.483c-.629-.628.314-1.57.942-.942l6.196 6.195Z",
      clipRule: "evenodd"
    }
  )
);
var SvgDoubleCheckOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DoubleCheckOutlined_default = SvgDoubleCheckOutlined;

export { DoubleCheckOutlined_default as default };
